module.exports = __webpack_public_path__ + "static/bulk-campaigns-af728d882c29105cba342ca1db3a3978.png";